/**
 * Remix button visibility for Malleable Content. Canonical deny list and show rules.
 */

import { isNodeEmpty } from '@atlaskit/editor-common/utils';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

/** Node types we never show Remix for. */
export const REMIX_DENY_LIST_V1: readonly string[] = [
	'mediaSingle',
	'mediaGroup',
	'media',
	'image',
	'extension',
	'bodiedExtension',
	'multiBodiedExtension',
	'embedCard',
	'blockCard',
	'inlineCard',
	'bodiedSyncBlock',
] as const;

const DENY_SET = new Set<string>(REMIX_DENY_LIST_V1);

function isRemixable(node: PMNode): boolean {
	const name = node.type?.name;
	return !!name && !DENY_SET.has(name);
}

export function shouldShowRemixForNode(node: PMNode): boolean {
	return isRemixable(node) && !isNodeEmpty(node);
}
